<template>
  <div class="news-page">
    <div class="gs-page-hero">
      <div class="gs-hero-art is-news" aria-hidden="true"></div>
      <div class="gs-page-hero-inner">
        <div>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSub }}</p>
        </div>
      </div>
      <div class="gs-page-hero-metrics">
        <div class="gs-page-hero-metric">
          <div class="metric-num"><em>{{ total }}</em></div>
          <div class="metric-label">条公开资讯</div>
        </div>
      </div>
    </div>

    <div class="news-toolbar">
      <button
        v-for="tab in typeTabs"
        :key="tab.value"
        type="button"
        class="news-chip"
        :class="{ 'is-active': String(activeType) === String(tab.value) }"
        @click="goType(tab.value)"
      >{{ tab.label }}</button>
    </div>

    <div class="news-stage">
      <div class="news-main" v-loading="loading">
        <article
          v-for="item in DetailDataList"
          :key="item.id"
          class="news-card"
          @click="openNewDetail(item)"
        >
          <div class="news-cover">
            <img v-if="coverSrc(item)" :src="coverSrc(item)" :alt="item.chineseTitle">
            <GsMediaPh v-else class="news-cover-ph" label="暂无配图" width="100%" height="100%" />
          </div>
          <div class="news-body">
            <div class="news-title-row">
              <span v-if="tagText(item)" class="news-tag">{{ tagText(item) }}</span>
              <h2><span v-if="String(item.whetherTop)==='1'" class="is-top-badge">置顶</span>{{ item.chineseTitle }}</h2>
            </div>
            <p class="news-digest">{{ item.digest }}</p>
            <div class="news-foot">
              <span>数据来源：{{ item.newsSource || '—' }}</span>
              <GsShare
                :id="item.id"
                :title="item.chineseTitle"
                :summary="item.digest"
                :image="coverSrc(item)"
              />
            </div>
          </div>
        </article>
        <div v-if="!DetailDataList.length && !loading" class="news-empty">
          <NoData />
        </div>
        <GsPagination
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
      <aside class="news-side">
        <userDetail :userDetailData="newsDetailData"></userDetail>
        <Interview class="mt20" />
      </aside>
    </div>
  </div>
</template>
<script>
import Interview from "@/components/Interview";
import userDetail from "@/components/UserDetail/index.vue";
import { getNewsList } from "@/api/api";
import { getDataType } from "@/api/Layout/index.js";
import GsPagination from '@/components/GsPagination/index.vue'
import GsShare from '@/components/GsShare/index.vue'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import NoData from '@/components/NoData/index.vue'
import { P } from '@/router/paths'

/** 0 表示「全部」，其余为 sys_news_information 字典里的资讯类型 */
const ALL_TAB = { label: '全部', value: 0 }

export default {
  name: "HotNewsList",
  components: {
    Interview,
    userDetail,
    GsPagination,
    GsShare,
    GsMediaPh,
    NoData
  },
  data() {
    return {
      newsDetailData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      DetailDataList: [],
      prodUrl: "https://shujuzichan.com/xwzx",
      loading: false,
      newsTypes: []
    };
  },
  computed: {
    /** tabBar 直接就是资讯类型，不再需要单独的筛选器 */
    typeTabs() {
      return [ALL_TAB].concat(this.newsTypes)
    },
    activeType() {
      const raw = this.$route.query.type
      const value = raw === undefined || raw === null || raw === '' ? 0 : Number(raw)
      return Number.isFinite(value) ? value : 0
    },
    type() {
      return this.activeType
    },
    pageTitle() {
      if (this.activeType === 0) return '全部资讯'
      const hit = this.newsTypes.find((item) => Number(item.value) === this.activeType)
      return hit ? hit.label : '全部资讯'
    },
    pageSub() {
      if (this.activeType === 0) return '按资讯类型分类浏览已发布的公开资讯。'
      const hit = this.newsTypes.find((item) => Number(item.value) === this.activeType)
      return hit ? `「${hit.label}」分类下的公开资讯。` : '按资讯类型分类浏览已发布的公开资讯。'
    }
  },
  watch: {
    type() {
      this.currentPage = 1
      this.getNewList(this.currentPage, this.pageSize)
    }
  },
  created() {
    this.loadNewsTypes()
    this.getNewList(this.currentPage, this.pageSize);
    this.getNewList1();
  },
  methods: {
    goType(next) {
      const value = Number(next) || 0
      if (String(this.activeType) === String(value)) return
      this.$router.push({ path: P.news, query: value ? { type: String(value) } : {} })
    },
    loadNewsTypes() {
      getDataType('sys_news_information').then((res) => {
        const list = (res && res.data) || []
        this.newsTypes = list
          .map((item) => ({ label: item.dictLabel, value: Number(item.dictValue) }))
          .filter((item) => item.label && Number.isFinite(item.value))
          .sort((a, b) => a.value - b.value)
      }).catch(() => {
        this.newsTypes = []
      })
    },
    tagText(item) {
      const raw = item && item.rangeTypeName
      if (!raw) return ''
      return String(raw).split(',')[0]
    },
    /** 封面统一取该资讯类别对应的配图，取不到再回落首页图 */
    coverSrc(item) {
      let src = ''
      const raw = item && item.categoryImages
      if (raw) {
        try {
          const map = typeof raw === 'object' ? raw : JSON.parse(String(raw))
          let cats = item.type
          if (typeof cats === 'string' && cats.charAt(0) === '[') { try { cats = JSON.parse(cats) } catch (e) { cats = [] } }
          const list = Array.isArray(cats) ? cats : String(cats || '').split(',')
          for (const c of list) {
            const k = String(c).trim()
            if (map && map[k]) { src = map[k]; break }
          }
        } catch (e) { src = '' }
      }
      if (!src) src = (item && item.homePicture) || ''
      if (!src) return ''
      if (/^https?:\/\//i.test(src)) return src
      if (String(src).startsWith('/xwzx/')) return 'https://shujuzichan.com' + src
      return this.prodUrl + src
    },
    openNewDetail(item) {
      this.$router.push(P.newsDetail(item.id));
    },
    getNewList1() {
      getNewsList({
        pageNum: 1,
        pageSize: 10,
        type: 2,
        whetherPublish: '1'
      }).then(response => {
        this.newsDetailData = (response && response.rows) || [];
      });
    },
    getNewList(currentPage, pageSize) {
      this.loading = true
      const params = {
        pageNum: currentPage,
        pageSize: pageSize,
        whetherPublish: '1'
      }
      // 不选类型时查全部
      if (this.activeType !== 0) params.type = this.activeType
      getNewsList(params).then(response => {
        this.DetailDataList = (response && response.rows) || [];
        this.total = (response && response.total) || 0;
        this.loading = false
      }).catch(() => {
        this.loading = false
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNewList(this.currentPage, this.pageSize);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style scoped>
.news-page {
  width: 100%;
  padding-bottom: 40px;
}
.news-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 18px 0 20px;
}
.news-chip {
  height: 32px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: #F2F6FB;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
  font-family: inherit;
}
.news-chip.is-active {
  background: #0165FF;
  color: #fff;
  font-weight: 600;
}
.news-stage {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}
.news-card {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 16px;
  margin-bottom: 14px;
  padding: 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 22px rgba(17, 24, 36, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.news-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(1, 101, 255, 0.12);
}
.news-cover {
  width: 220px;
  height: 132px;
  border-radius: 8px;
  overflow: hidden;
  background: #E8F1FF;
  flex-shrink: 0;
}
.news-cover img,
.news-cover-ph {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.news-body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.news-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.news-tag {
  flex: 0 0 auto;
  height: 22px;
  padding: 0 8px;
  border-radius: 4px;
  background: #0165FF;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  margin-top: 2px;
}
.news-title-row h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #111824;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news-digest {
  margin: 8px 0 0;
  color: #5B6B82;
  font-size: 14px;
  line-height: 22px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  color: #7B889C;
  font-size: 12px;
}
.news-foot > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-empty {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1100px) {
  .news-stage {
    grid-template-columns: 1fr;
  }
  .news-side {
    order: 2;
  }
}
@media (max-width: 960px) {
  .news-page .gs-page-hero {
    margin-bottom: 12px;
  }
  .news-toolbar,
  .news-stage {
    width: calc(100% - 24px);
    margin-left: auto;
    margin-right: auto;
  }
  .news-toolbar {
    padding: 0;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .news-chip {
    height: 28px;
    padding: 0 10px;
    font-size: 12px;
  }
  .news-card {
    grid-template-columns: 1fr;
    padding: 0 0 12px;
    gap: 0;
  }
  .news-cover {
    width: 100%;
    height: 168px;
    border-radius: 12px 12px 0 0;
  }
  .news-body {
    padding: 12px 12px 0;
  }
  .news-title-row h2 {
    font-size: 16px;
    line-height: 22px;
  }
}

.is-top-badge { display:inline-block; margin-right:6px; padding:1px 6px; font-size:12px; color:#fff; background:#D9001B; border-radius:4px; vertical-align:middle; }
</style>
